module.exports = __webpack_public_path__ + "img/ctrl-circuit-stub-down-1.6f89e7e6.svg";